module.exports = __webpack_public_path__ + "img/df114b2.jpg";